import { createAsyncThunk } from "@reduxjs/toolkit";
import { Axios } from "api/axios";
import { InventoryAxios } from "api/InventoryAxios";
import axios from "axios";

// export interface District {
//   id?: string;
//   packageName: string;
//   districtCode: string;
//   districtName: string;
//   state: string;
//   status: boolean;
//   createBy?: string;
//   updatedBy?: string;
//   createDate?: string;
//   updateDate?: string;
// }
export interface PaginatedResponse<T> {
  count: number;
  total_pages: number;
  next: string | null;
  previous: string | null;
  results: T[];
}

export const fetchInventoryItemRequestPendingApproval = createAsyncThunk(
  "inventory/fetchInventoryItemRequestPendingApproval",
  async ({
    page,
    pageSize,
    sort,
    order,
    search,
    filters,
  }: {
    page: number;
    pageSize: number;
    search?: string;
    sort?: string;
    order?: "asc" | "desc" | "";
    filters?: any;
  }) => {
    try {
      const params = new URLSearchParams();
      params.append("page", page.toString());
      params.append("page_size", pageSize.toString());
      if (search) params.append("search", search);
      if (sort) {
        const orderingValue = order === "desc" ? `-${sort}` : sort;
        params.append("ordering", orderingValue);
      }

      if (filters && filters.length > 0) {
        console.log(JSON.stringify(filters));
        filters.forEach(
          ({
            filterField,
            filterValue,
          }: {
            filterField: string;
            filterValue: any;
          }) => {
            if (
              filterField &&
              filterValue !== undefined &&
              filterValue !== null
            ) {
              if (typeof filterValue === "object" && filterValue !== null) {
                Object.entries(filterValue).forEach(([key, value]) => {
                  if (value !== undefined && value !== null && value !== "") {
                    params.append(key, String(value));
                  }
                });
              } else {
                params.append(filterField, filterValue);
              }
            }
          }
        );
      }

      const response: any = await InventoryAxios.get(`/api/inventory_item_request/pending-approval-list/?${params.toString()}`);

      return {
        data: response?.data?.data || [],
      rowCount: response?.data?.count || 0,
      };
    } catch (error: any) {
      console.error(
        "fetch Item Request  List error:",
        error.response?.data || error.message
      );
      throw new Error("Network Error");
    }
  }
);

export const pendingApprovalViewApproved = createAsyncThunk(
  "approved/pendingApprovalViewApproved",
  async ({ id, payload }: { id: string; payload: any }, { rejectWithValue }) => {
    try {
      const res = await InventoryAxios.post(
        `api/inventory_item_request/approve/${id}/`,
        payload
      );
      return res.data;
    } catch (error: any) {
      console.error("Failed to approved:", error?.response?.data || error.message);
      return rejectWithValue(error?.response?.data || "Something went wrong");
    }
  }
);

export const pendingRejectViewApproved = createAsyncThunk(
  "approved/pendingRejectViewApproved",
  async ({ id, payload }: { id: string; payload: any }, { rejectWithValue }) => {
    try {
      const res = await InventoryAxios.post(
        `api/inventory_item_request/reject/${id}/`,
        payload
      );
      return res.data;
    } catch (error: any) {
      console.error("Failed to Reject:", error?.response?.data || error.message);
      return rejectWithValue(error?.response?.data || "Something went wrong");
    }
  }
);


